// @ts-check

import {
  bulkTagsService, 
  $ngStateService
} from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  SET_BULK_TAGS_REFERENCES,
  SET_BULK_TAGS,
  SET_BULK_TAGS_URL
} from './mutationTypes';
import {
  GET_BULK_TAGS,
  GET_BULK_TAGS_REFERENCES, 
  DELETE_BULK_TAGS,
  GET_BULK_TAGS_URL
} from './actionTypes';

import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR
} from '@/store/helpers';


/** @type {import('vuex').ActionTree} */
const actions = {

  /**
   * Get all Bulk Tags
   */
  async [GET_BULK_TAGS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_BULK_TAGS });
    try {
      const response = await bulkTagsService.getBulkTags(rootState.currentAccountId);
      const bulkTags = response.data.bulkTagUploads;
      commit(SET_BULK_TAGS, bulkTags);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_BULK_TAGS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_BULK_TAGS, error: e });
    }
  }, 

  /**
   * Delete Bulk Tags
   */
  async [DELETE_BULK_TAGS]({ rootState, commit, dispatch }, bulkTagUploadId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: DELETE_BULK_TAGS });
    try {
      await bulkTagsService.deleteBulkTags(rootState.currentAccountId, bulkTagUploadId);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: DELETE_BULK_TAGS });
      dispatch(GET_BULK_TAGS);
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: DELETE_BULK_TAGS, error: e });
    }
  },

  /**
   * Get Bulk Tags url
   */
  async [GET_BULK_TAGS_URL]({ rootState, commit }, bulkTagUploadId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_BULK_TAGS_URL });
    try {
      const response = await bulkTagsService.getBulkTagsUrl(rootState.currentAccountId, bulkTagUploadId);
      const bulkTagsUrl = response.data.fileUrl;
      commit(SET_BULK_TAGS_URL, bulkTagsUrl);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_BULK_TAGS_URL });
    } catch (e) {
      if(e.status === 404) {
        const errorMessage = 'File is unavailable for download.';
        commit(SET_ACTION_STATUS_ERROR, { actionName: GET_BULK_TAGS_URL, error: e, errorMessage });
      } else {
        commit(SET_ACTION_STATUS_ERROR, { actionName: GET_BULK_TAGS_URL, error: e });
      }

    }
  },

  /**
   * Get references for Bulk Tag
   */
  async [GET_BULK_TAGS_REFERENCES]({ rootState, commit }, bulkTagUploadId) {
    commit(SET_BULK_TAGS_REFERENCES, []);
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_BULK_TAGS_REFERENCES });
    try {
      var response = await bulkTagsService.getBulkTagsReferences(rootState.currentAccountId, bulkTagUploadId);
      // Assemble all the types of references
      const references = [];
      if (response.data.eventcallbacks) {
        references.push(...response.data.eventcallbacks.map(eventcallback => {
          return {
            type: 'Pixel',
            name: eventcallback.eventcallbackName,
            id: eventcallback.eventcallbackId,
            link: $ngStateService.href('dashboard.callbacks', {}, {absolute: true})
          };
        }));
      }

      if (response.data.ivrtrees) {
        references.push(...response.data.ivrtrees.map(ivrtree => {
          return {
            type: 'Call Flow',
            name: ivrtree.ivrtreeName,
            id: ivrtree.ivrtreeId,
            link: $ngStateService.href('dashboard.call-flow.edit', { treeId: ivrtree.ivrtreeId }, {absolute: true})
          };
        }));
      }

      if (response.data.campaigns) {
        references.push(...response.data.campaigns.map(campaign => {
          return {
            type: 'Campaign',
            name: campaign.campaignName,
            id: campaign.campaignId,
            link: $ngStateService.href('dashboard.campaign', { campaignId: campaign.campaignId }, { absolute: true })
          };
        }));
      }

      if (response.data.targets) {
        references.push(...response.data.targets.map(target => {
          return {
            type: 'Target',
            name: target.targetName,
            id: target.targetId,
            link: $ngStateService.href('dashboard.target.edit', { targetId: target.targetId }, {absolute: true})
          };
        }));
      }

      if (response.data.pingtreetargets) {
        references.push(...response.data.pingtreetargets.map(pingtreetarget => {
          return {
            type: 'Ring Tree Target',
            name: pingtreetarget.pingtreetargetName,
            id: pingtreetarget.pingtreetargetId,
            link: $ngStateService.href('dashboard.ringtreetarget.edit', { pingTreeTargetId: pingtreetarget.pingtreetargetId }, {absolute: true})
          };
        }));
      }

      commit(SET_BULK_TAGS_REFERENCES, references);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_BULK_TAGS_REFERENCES });
    } catch (e) {
      commit(SET_BULK_TAGS_REFERENCES, []);
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_BULK_TAGS_REFERENCES, error: e });
    }
  },

};

export default actions;